export const redux_getAllProposals = (data: any) => ({
    type: 'GET_ALL_PROPOSALS',
    payload: data,
});

export const redux_getProposal = (data: any) => ({
    type: 'GET_PROPOSAL',
    payload: data,
});

export const redux_updateProposal = (data: any) => ({
    type: 'UPDATE_PROPOSAL',
    payload: data,
});

export const redux_createProposal = (data: any) => ({
    type: 'CREATE_PROPOSAL',
    payload: data,
});

export const redux_proposalActionStarts = () => ({
    type: 'PROPOSAL_ACTION_STARTS',
});

export const redux_proposalActionErrors = (error: string) => ({
    type: 'PROPOSAL_ACTION_ERRORS',
    payload: error,
});

export const redux_resetProposalErrors = () => ({
    type: 'RESET_PROPOSAL_ERRORS',
}); 